import { CommonModule, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Store } from '@ngxs/store';
import { forEach } from 'lodash';
import {
  DocumentUploadDialogComponent
} from 'ng2-app/documents/document-upload-dialog/document-upload-dialog.component';
import { fileTypesAccepted } from 'ng2-app/models/const/fileTypesAccepted';
import { DocumentCategory } from 'ng2-app/models/dto/document-category.model';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';
import { UploadDocument } from 'ng2-app/store/documents/document.actions';
import { DocumentState } from 'ng2-app/store/documents/document.state';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { AddStackableNotificationError } from 'ng2-app/store/stackable-notifications/StackableNotifications.actions';

@Component({
  selector: 'app-document-upload-button',
  templateUrl: './document-upload-button.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
})
export class DocumentUploadButtonComponent {

  isUploading = toSignal( this.store.select( DocumentState.isUploading ) );
  isFundingDesk = toSignal( this.store.select( LenderUserState.hasRole('fundingDesk') ) );
  allDocumentCategories = toSignal( this.store.select( DocumentState.documentCategories) );
  borrowerId = toSignal( this.store.select( BorrowerState.borrowerId ) );
  @Input() categories: DocumentCategory[];
  @Input() uploadCallback: any;

  protected readonly documentUploadLimit = 20;
  protected readonly typesAccepted = fileTypesAccepted;

  constructor(
    private dialog: MatDialog,
    private store: Store,
  ) {}

  uploadDocuments(documents) {
    if (documents.length) {
      if(documents.length > this.documentUploadLimit) {
        return this.store.dispatch( new AddStackableNotificationError({
          title: 'Error',
          subTitle: `May only upload up to ${this.documentUploadLimit} documents at a time`,
        }));
      }

      return this.isFundingDesk() ?
        this.dialog.open(DocumentUploadDialogComponent, {
          width: 'auto',
          height: 'auto',
          autoFocus: false,
          data: {
            documents: documents,
            categories: this.categories || this.allDocumentCategories(),
          }
        }).afterClosed().subscribe((data) => {
          data && this.handleUploadDocuments(data);
        }) : this.handleUploadDocuments(documents);
    }
  }

  handleUploadDocuments(documents: FileList) {
    if(typeof this.uploadCallback === 'function') {
      return this.uploadCallback(documents);
    }
    const borrowerId = this.borrowerId() as number;
    forEach(documents, (document => {
      this.store.dispatch(new UploadDocument(document, borrowerId));
    }));
  }
}
